const DEFAULT_CURRENCY = 'GBP';

const toNumber = (value, fallback = 0) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : fallback;
  if (typeof value !== 'string') return fallback;

  const parsed = Number(value.replace(/[^0-9.-]+/g, ''));
  return Number.isFinite(parsed) ? parsed : fallback;
};

const getItemVariant = (item) => {
  if (item?.variation) return item.variation;
  if (item?.variant) return item.variant;
  if (Array.isArray(item?.meta_data)) {
    return item.meta_data
      .map((meta) => meta?.display_value || meta?.value)
      .filter(Boolean)
      .join(', ');
  }
  return undefined;
};

export const pushDataLayerEvent = (event, ecommerce = {}) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({ event, ecommerce });
};

export const cartItemToDataLayerItem = (item, index = 0) => ({
  item_id: String(item?.variation_id || item?.id || item?.product_id || ''),
  item_name: item?.name || item?.title || '',
  item_variant: getItemVariant(item),
  price: item?.price
    ? toNumber(item.price)
    : toNumber(item?.subtotal || item?.total) / toNumber(item?.quantity, 1),
  quantity: toNumber(item?.quantity, 1),
  index,
});

export const productToDataLayerItem = (product, variant = null, quantity = 1) => ({
  item_id: String(variant?.id || product?.id || ''),
  item_name: product?.name || '',
  item_variant: variant?.name,
  price: toNumber(variant?.price || product?.price, toNumber(product?.variants?.[0]?.price)),
  quantity: toNumber(quantity, 1),
});

export const orderToPurchaseEvent = (order) => {
  const items = Array.isArray(order?.line_items) ? order.line_items : [];

  return {
    transaction_id: String(order?.id || order?.order_key || ''),
    currency: order?.currency || DEFAULT_CURRENCY,
    value: toNumber(order?.total),
    tax: toNumber(order?.total_tax),
    shipping: toNumber(order?.shipping_total),
    coupon: order?.coupon_lines?.[0]?.code,
    items: items.map(cartItemToDataLayerItem),
  };
};

export const getDataLayerValue = (items) => (
  items.reduce((total, item) => total + (toNumber(item.price) * toNumber(item.quantity, 1)), 0)
);

export { DEFAULT_CURRENCY, toNumber };
